<template>
  <div class="common-header">
    <div class="header-banner">
      <div class="index-banner-center">
        <div class="logo-wrapper">
          <div class="logo-left">
            <img src="/static/img/logo.png" alt>
          </div>
          <div class="logo-right">
            <div class="lr-img-box">
              <img src="/static/img/big-title.png" alt>
              <img class="logo-right-english" src="/static/img/small-title.png" alt>
            </div>
            <div class="lang-switch">
              <span @click="langSwitch('E')" :class="languageActive==='E'?'languageActive':''">English</span>/
              <span @click="langSwitch('Z')" :class="languageActive==='Z'?'languageActive':''">中文</span>
            </div>
          </div>
        </div>
        <div class="nav-wrapper">
          <div class="nav-header">
            <div class="nav-item" @click="toPage('/')">
              <img src="/static/img/home-icon1.png" alt>
              <div class="text">首页</div>
            </div>
            <div class="nav-item" @click="toPage('/org')" :class="{'nav-item-active':$route.path.indexOf('org')!=-1}">
              <img src="/static/img/home-icon2.png" alt>
              <div class="text">中心概况</div>
            </div>
            <div class="nav-item" @click="toPage({name:'comPartyList',query:{section:2}})" :class="{'nav-item-active':$route.path.indexOf('com-party')!=-1}">
              <img src="/static/img/home-icon7.png" alt>
              <div class="text">党群建设</div>
            </div>
            <div class="nav-item" @click="toPage('/businesss',1)" :class="{'nav-item-active':$route.path.indexOf('businesss')!=-1&&$route.query.type==1}">
              <img src="/static/img/home-icon3.png" alt>
              <div class="text">海洋标准化</div>
            </div>
            <div class="nav-item" @click="toPage('/businesss',2)" :class="{'nav-item-active':$route.path.indexOf('businesss')!=-1&&$route.query.type==2}">
              <img src="/static/img/home-icon6.png" alt>
              <div class="text">海洋计量</div>
            </div>
            <div class="nav-item" @click="toPage('/businesss',3)" :class="{'nav-item-active':$route.path.indexOf('businesss')!=-1&&$route.query.type==3}">
              <img src="/static/img/home-icon8.png" alt>
              <div class="text">海洋质量监督</div>
            </div>
            <div class="nav-item" @click="toPage('/cooperation')" :class="{'nav-item-active':$route.path.indexOf('cooperation')!=-1}">
              <img src="/static/img/home-icon4.png" alt>
              <div class="text">科研与国际合作</div>
            </div>
            <div class="nav-item" @click="toPage('/person')" :class="{'nav-item-active':$route.path.indexOf('person')!=-1}">
              <img src="/static/img/home-icon5.png" alt>
              <div class="text">人才队伍</div>
            </div>
            <div class="nav-item" @click="toPage({path:'/',query:{fr:'zxfw'}})">
              <img src="/static/img/home-icon9.png" alt>
              <div class="text">在线服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      languageActive: "Z",  //当前使用语言
    }
  },
  methods:{
    toPage(url,type) {
      if(url==='/businesss'){
        this.$router.push({
          name: "Redirect",
          query: {
            type: type
          }
        });
      }else{
        this.$router.push(url);
      }
    },
    //切换语言逻辑
    langSwitch(type){
      return;  //暂不开放
    },
  }
}
</script>

<style scoped>
.header-banner {
  width: 100%;
  height: 362px;
  background: url(/static/img/common-hea.png) no-repeat center center;
  background-size: 2562px 362px;
  margin-bottom: 20px;
  position: relative;
  box-sizing: border-box;
}
.index-banner-center {
  width: 1230px;
  margin: 0 auto;
  padding: 40px 0 0 0;
}
.logo-wrapper {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.logo-left {
  margin-right: 40px;
}
.logo-left img{
  width: 104px;
}
.logo-right{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.logo-right img{
  width: 555px;
}
.lang-switch{
  width: 250px;
  text-align: right;
  color: white;
  font-size: 20px;
  color: #71A7E8;
}
.lang-switch span{
  cursor: pointer;
}
.languageActive{
  color: #fff;
}
.nav-wrapper {
  margin-top: 90px;
}
.nav-header {
  width: 100%;
  height: 102px;
  background: url(/static/img/nav-bj.png) no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
  justify-content: space-between;
}
.nav-item {
  /* width: 160px; */
  flex: 1;
  height: 100%;
  text-align: center;
  padding: 15px 0;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 19px;
}
.nav-item-active {
  background: #194eb0;
}
.nav-item img {
  height: 40px;
  display: inline-block;
  margin: 0 auto;
}
.nav-item .text {
  line-height: 45px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  position: relative;
}
.logo-right-english{
  margin-top: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Index/header.vue